export default "__VITE_ASSET__fdkiHojh__"